module.exports = __webpack_public_path__ + "fonts/nunitosans-semibold-webfont.3654109.woff2";